module.exports = __webpack_public_path__ + "static/media/mailchimp.bf56dc41.png";